(ns ductile.ui.transit
  (:require [cognitect.transit :as transit]
            [ductile.time.transit-handlers :as time-handlers]
            [ductile.workflow.form-recorder :as rec]
            [nextjournal.clerk.viewer :as clerk-viewer]
            [nextjournal.log :as log]))

(def clerk-write-handlers
  {clerk-viewer/RenderFn (transit/write-handler "clerk/RenderFn" #(vector (dissoc % :form :f) (:form %)))})

(def write-handlers (atom (merge time-handlers/write-handlers
                                 clerk-write-handlers
                                 {rec/WorkflowFn (transit/write-handler "ductile/WorkflowFn" (juxt :form :f))})))
(def clerk-read-handlers
  {"clerk/RenderFn" (fn [opts+form] (clerk-viewer/->render-fn+opts opts+form))})

(def read-handlers (atom (merge time-handlers/read-handlers
                                {"f" (fn [x] (js/parseFloat x))  ;; quickfix for BigDecimals
                                 "regex" (fn [x] (js/RegExp. x))}
                                clerk-read-handlers)))

(def transit-json-reader
  (transit/reader :json {:handlers @read-handlers}))

(def transit-json-writer
  (transit/writer :json {:handlers @write-handlers}))

(defn write [edn]
  (transit/write transit-json-writer edn))

(defn read [transit]
  (transit/read transit-json-reader transit))
